const React = require('react');
const Storage = require('utils/storage');
const { useEffect, useState } = React;
const { default: Styled } = require('styled-components');
const { context } = require('app-context');

const { getDisplayImageUrl } = require('utils/image');

const Ui = require('./styles');

const internals = {};

module.exports = function HomeGamification({ user, schoolId }) {

    const eligible = Number(schoolId || user?.schoolId) === 240394 && user?.roleId === 2;
    const [prizes, setPrizes] = useState(null);
    const { Panel, RememberedSection } = internals;
    const sectionScope = `gamification:${schoolId || user?.schoolId}:${user?.id}:${user?.roleId}`;
    useEffect(() => {

        let current = true;
        setPrizes(null);
        if (eligible) {
            context.api.nearpeer.gamification.prizes().then((data) => current && setPrizes(data)).catch(() => {});
        }
        return () => { current = false; };
    }, [eligible, schoolId, user?.schoolId, user?.id, user?.roleId]);

    if (!eligible) { return null; }
    return <>
        {prizes?.enabled && prizes.current && <Panel aria-label="This week's prize">
            <RememberedSection key={`${sectionScope}:prize`} storageKey={`${sectionScope}:prize`} title='This week’s prize'>
                <p>{internals.dates(prizes.current.weekStart, prizes.current.weekEnd)}</p>
                <p>{prizes.current.description}</p>
                {prizes.current.imageUrl && <img src={getDisplayImageUrl(prizes.current.imageUrl)} alt='This week’s prize' />}
                {prizes.current.sponsor && <p>Sponsored by {prizes.current.sponsor}</p>}
                <p>Finish in the top {prizes.current.rankCutoff} on this week’s leaderboard to qualify.</p>
            </RememberedSection>
        </Panel>}
        {prizes?.enabled && !!prizes.recent?.winners?.length && <Panel aria-label='Recent weekly prize winners'>
            <h2>Congratulations to our latest weekly winners!</h2>
            <p>{internals.dates(prizes.recent.weekStart, prizes.recent.weekEnd)}</p>
            <p>{prizes.recent.winners.map(({ firstName }) => firstName).join(', ')}</p>
            <p>Winners: check your bell notifications for your claim code and redemption instructions.</p>
        </Panel>}
    </>;
};

internals.RememberedSection = function RememberedSection({ storageKey, title, defaultOpen = false, children }) {

    const [open, setOpen] = useState(() => {

        try {
            const saved = Storage.getItem(storageKey);
            return saved === null ? defaultOpen : saved === 'true';
        }
        catch { return defaultOpen; }
    });
    return <details open={open} onToggle={(event) => {

        const expanded = event.currentTarget.open;
        setOpen(expanded);
        try { Storage.setItem(storageKey, String(expanded)); }
        catch { /* The section still works when browser storage is unavailable. */ }
    }}><summary><h2>{title}</h2></summary>{children}</details>;
};

internals.dates = (start, end) => `${internals.date(start)} – ${internals.date(end)}`;
internals.date = (value) => new Date(`${value}T12:00:00Z`).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
internals.Panel = Styled.section`${Ui.surface}
    box-sizing: border-box; width: 100%; padding: 20px;
    && h2, && summary { font-size: 20px; font-weight: 700; margin: 0 0 12px; }
    summary h2 { display: inline; }
    && h3 { font-size: 16px; } && p, && li, && label { font-size: 16px; line-height: 1.5; }
    img { max-width: 100%; max-height: 240px; object-fit: contain; }
    summary { cursor: pointer; } form { display: flex; flex-wrap: wrap; gap: 16px; align-items: end; }
    label { display: flex; flex-direction: column; gap: 6px; }
    input, select { padding: 10px; border: 1px solid ${Ui.divider}; border-radius: 6px; font: inherit; max-width: 100%; }
    ul { padding-left: 20px; }
`;
